<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_6"></a><b>Murder in Peking</b></h1>
<p class="author">Vincent Starrett</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?26394760